import { Grid, Card, CardContent, Typography, Box, Divider, Modal } from "@mui/material";
import "../Common/css/styles.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAttendanceRecords } from "src/Services/attendance_api";
import { getNotices } from "src/Services/notice_api";
import { getInstitutionUpdates, getStats, getTopSPG } from "src/Services/admin_api";
import { Campaign } from "@mui/icons-material";
import { TrophyFilled } from "@ant-design/icons";

export default function AdminDashboard() {
  // statsData expected shape e.g.:
  // {"totalStudents":4,"totalTeachers":2,"latePayments":0,"newTickets":5}
  const [statsData, setStatsData] = React.useState<any>(null);
  const [spgStudents, setSpgStudents] = React.useState<any[]>([]);

  const s = statsData || {};
  const studentsCount = Number.isFinite(Number(s.totalStudents)) ? s.totalStudents : 0;
  const teachersCount = Number.isFinite(Number(s.totalTeachers)) ? s.totalTeachers : 0;
  const latePaymentsCount = Number.isFinite(Number(s.latePayments)) ? s.latePayments : 0;
  const newTicketsCount = Number.isFinite(Number(s.newTickets)) ? s.newTickets : 0;

  const stats = [
    { id: "students", label: "Students", value: studentsCount, accent: "#2e86de", delta: "Registered Students" },
    { id: "teachers", label: "Teachers", value: teachersCount, accent: "#8e44ad", delta: "Registered Teachers" },
    { id: "late-payments", label: "Late Payments", value: latePaymentsCount, accent: "#e74c3c", delta: "Late Payments" },
    { id: "new-tickets", label: "New Tickets", value: newTicketsCount, accent: "#f39c12", delta: "New Tickets" },
  ];

  const username = sessionStorage.getItem("username") || "";
  const token = sessionStorage.getItem("token") || "";
  const house = sessionStorage.getItem("house") || "N/A";

  const [notices, setNotices] = React.useState<any[]>([]);
  const [institutionUpdates, setInstitutionUpdates] = React.useState<any[]>([]);
  const [openNotice, setOpenNotice] = React.useState(false);
  const [selectedNotice, setSelectedNotice] = React.useState<any>(null);
  const [openAllNotices, setOpenAllNotices] = React.useState(false);
  const [selectedFullNotice, setSelectedFullNotice] = React.useState<any>(null);
  const [otherHouses, setOtherHouses] = React.useState<string[]>([]);
  const [activeSlide, setActiveSlide] = React.useState(0);
  const [record, setRecord] = useState<any>("");

  const userId = sessionStorage.getItem("userId") || "";

  const navigate = useNavigate();

  const handleGetStats = async () => {
    try {
      const res = await getStats(token);
      // accept either object or array result; normalize to object
      setStatsData(res || null);
    } catch (error) {
      setStatsData(null);
    }
  }

  const handleGetTopStudents = async () => {
    try {
      const res = await getTopSPG(token);
      setSpgStudents(res);
    } catch (error) {
      setSpgStudents([]);
    }
  }

  useEffect(() => {
    handleGetStats();
    handleGetTopStudents();
  }, []);

  useEffect(() => {
    // handleGetAttendanceRecords();
  }, []);

  const handleOpenAllNotices = () => {
    setOpenAllNotices(true);
    setSelectedFullNotice(notices[0]); // auto-select first notice
  };

  const handleCloseAllNotices = () => {
    setOpenAllNotices(false);
    setSelectedFullNotice(null);
  };

  const carouselRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (carouselRef.current && institutionUpdates.length > 0) {
        const firstChild = carouselRef.current.children[0];
        if (firstChild) {
          const width = (firstChild as HTMLElement).offsetWidth + 15; // 15px gap
          carouselRef.current.scrollBy({ left: width, behavior: "smooth" });

          // Update active slide index
          setActiveSlide((prev) => (prev + 1) % institutionUpdates.length);

          // Move first child to end for infinite loop
          setTimeout(() => {
            if (carouselRef.current) {
              carouselRef.current.appendChild(firstChild);
              carouselRef.current.scrollLeft -= width;
            }
          }, 500);
        }
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [institutionUpdates]);

  const handleOpenNotice = (notice: any) => {
    setSelectedNotice(notice);
    setOpenNotice(true);
  };

  const handleCloseNotice = () => {
    setOpenNotice(false);
    setSelectedNotice(null);
  };

  const handleGetNotices = async () => {
    try {
      const res = await getNotices(token);
      setNotices(res);
    } catch (error) {
      setNotices([]);
    }
  }

  const handleGetInstitutionUpdates = async () => {
    try {
      const res = await getInstitutionUpdates(token);
      setInstitutionUpdates(res);
    } catch (error) {
      setInstitutionUpdates([]);
    }
  }

  useEffect(() => {
    handleGetNotices();
    handleGetInstitutionUpdates();
  }, []);

  return (
    <div className="comman-outer">
      <Grid container spacing={2} className="ad-stats-grid">
        {stats.map((s) => (
          <Grid item xs={12} sm={6} md={3} key={s.id}>
            <Card className="ad-stat-card" elevation={6}>
              <CardContent className="ad-stat-card-content">
                <Box className="ad-stat-left">
                  <Box
                    className="ad-stat-icon"
                    style={{ background: `${s.accent}22`, color: s.accent }}
                    aria-hidden
                  >
                    {/* simple icon placeholder */}
                    {s.id === "students" ? "🎓" : s.id === "teachers" ? "👩‍🏫" : s.id === "late-payments" ? "⏰" : "🎫"}
                  </Box>
                </Box>

                <Box className="ad-stat-right">
                  <Typography className="ad-stat-label" variant="subtitle2">
                    {s.label}
                  </Typography>
                  <Typography className="ad-stat-value" variant="h4">
                    {s.value}
                  </Typography>
                  <Typography className="ad-stat-delta" variant="caption">
                    {/* {s.delta} */}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
          <Grid item xs={12} md={8}>
            {/* Notice Board */}
            <div className="notice-board">
              <div className="notice-header">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <h3>Notice Board</h3>
                  <span className="notice-icon">
                    <Campaign style={{ color: "#a18102", fontSize: "26px" }} />
                  </span>
                </div>


                <div className="notice-right">

                  <button className="see-all-btn" onClick={handleOpenAllNotices}>See All</button>
                </div>
              </div>


              <div className="notice-list">
                {notices.length > 0 ? (
                  notices.slice(0, 5).map((item) => (
                    <div className="notice-item" key={item.id} onClick={() => handleOpenNotice(item)}>
                      <h4 className="notice-title">
                        {item.noticeTitle || "Untitled Notice"}
                      </h4>

                      <p className="notice-description">
                        {item.noticeMessage.length > 50 ? item.noticeMessage.slice(0, 50) + "..." : item.noticeMessage || "No description available."}
                      </p>

                      <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

                      <span className="notice-created-by">
                        {item.createdAt.split("T")[0]} - {item.userType === 2 ? item.userName : "Admin"}
                      </span>
                    </div>
                  ))
                ) : (
                  <p style={{ color: "#888", fontSize: "14px" }}>No notices found</p>
                )}
              </div>

            </div>

          </Grid>

          <Grid item xs={12} md={4}>
            {/* Notice Board */}
            <div className="notice-board">
              <div className="notice-header">
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <h3>Top 10 SPG</h3>
                  <span className="notice-icon">
                    <TrophyFilled style={{ color: "#a18102", fontSize: "26px" }} />
                  </span>
                </div>
              </div>

              <div className="notice-list">
                {/* map spg list */}
                {spgStudents.length > 0 ? (
                  spgStudents.slice(0, 10).map((student, index) => (
                    <div className="notice-item" key={student.userId || student.id || index}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h4 className="notice-title" style={{ margin: 0 }}>
                          {index + 1}. {student.fullName || student.userName || "Unnamed Student"}
                        </h4>
                        <div style={{ color: "#d3aa04", fontWeight: 800 }}>
                          {typeof student.totalMark === "number"
                            ? student.totalMark.toFixed(2)
                            : (parseFloat(String(student.totalMark || "0")) || 0).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p style={{ color: "#888", fontSize: "14px" }}>No students found</p>
                )}
              </div>
            </div>
          </Grid>        
      </Grid>

      <Modal open={openNotice} onClose={handleCloseNotice}>
        <Box className="notice-modal-container">
          {selectedNotice && (
            <>
              <h2 className="notice-modal-title">{selectedNotice.noticeTitle}</h2>

              <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

              <p className="notice-modal-description">
                {selectedNotice.noticeMessage}
              </p>

              <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

              <div className="notice-modal-footer">
                <span>
                  Posted By:{" "}
                  {selectedNotice.userType === 2
                    ? selectedNotice.userName
                    : "Admin"}
                </span>

                <span>
                  {selectedNotice.createdAt.split("T")[0]}
                </span>
              </div>

              <button className="notice-modal-close-btn" onClick={handleCloseNotice}>
                Close
              </button>
            </>
          )}
        </Box>
      </Modal>

      {/* FULL SCREEN NOTICE BOARD MODAL */}
      <Modal open={openAllNotices} onClose={handleCloseAllNotices}>
        <Box className="full-notice-modal">
          {/* HEADER */}
          <div className="full-notice-header">
            <h2>All Notices</h2>
            <button className="full-notice-close-btn" onClick={handleCloseAllNotices}>
              ✕
            </button>
          </div>

          <div className="full-notice-body">

            {/* LEFT PANE: NOTICE LIST */}
            <div className="full-notice-list">
              {notices.length > 0 ? (
                notices.map((n) => (
                  <div
                    key={n.id}
                    className={`full-notice-list-item ${selectedFullNotice?.id === n.id ? "active" : ""
                      }`}
                    onClick={() => setSelectedFullNotice(n)}
                  >
                    <h4>{n.noticeTitle}</h4>
                    <p>
                      {n.noticeMessage.length > 60
                        ? n.noticeMessage.slice(0, 60) + "..."
                        : n.noticeMessage}
                    </p>
                    <span className="notice-date-small">
                      {n.createdAt.split("T")[0]}
                    </span>
                  </div>
                ))
              ) : (
                <p className="no-notice-text">No notices available</p>
              )}
            </div>

            {/* RIGHT PANE: NOTICE PREVIEW */}
            <div className="full-notice-preview">
              {selectedFullNotice ? (
                <>
                  <h2 className="preview-title">{selectedFullNotice.noticeTitle}</h2>
                  <Divider style={{ backgroundColor: "#444", margin: "10px 0" }} />

                  <p className="preview-description">
                    {selectedFullNotice.noticeMessage}
                  </p>

                  <Divider style={{ backgroundColor: "#444", margin: "10px 0" }} />

                  <p className="preview-footer">
                    Posted By:{" "}
                    {selectedFullNotice.userType === 2
                      ? selectedFullNotice.userName
                      : "Admin"}
                    <br />
                    Date: {selectedFullNotice.createdAt.split("T")[0]}
                  </p>
                </>
              ) : (
                <p className="preview-placeholder">Select a notice to preview</p>
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
